import React from 'react';
import { isMobile } from '@automation/core/utils';
import MainPage from '../../features/MainPage/MainPage';
import Layout from '../../common/components/Layout/Layout';

async function action({ userAgent }) {
  return {
    title: 'فرصت‌های شغلی تپسی در شهرهای مختلف ایران | TAPSI',
    description: 'در این صفحه از آخرین فرصت‌های شغلی جهت استخدام شرکت تپسی در شهرهای تهران، مشهد، اصفهان، شیراز و... مطلع شوید.',
    chunks: ['home-page'],
    component: (
      <Layout isMobile={isMobile(userAgent)}>
        <MainPage isMobile={isMobile(userAgent)} />
      </Layout>
    ),
  };
}

export default action;
